import { createQueryClient, shouldRetry, getRetryDelay } from "@njbsoft/api-client";
import { ApiError } from "@njbsoft/api-client";
import { i18n } from "@njbsoft/i18n";
import { toast } from "sonner";

export { shouldRetry, getRetryDelay };

// Customer reads do NOT retry. The customer stack runs org-less account_user RLS
// reads with no sargable org bound, so a single timed-out read (-> 500) retried
// twice (the shared shouldRetry default) triples pool pressure at exactly the
// wrong moment and tips the 10-conn pool into a metastable retry collapse. 4xx
// was already non-retryable; this caps read-path 5xx + network at zero retries
// so a transient spike self-heals instead of cascading. Mutations keep the
// shared shouldRetry. Scoped to the customer app only — org/admin/company
// queryClients keep the shared 5xx-retries-twice behavior.
export function customerReadShouldRetry(_failureCount: number, _error: Error): boolean {
  return false;
}

export const queryClient = createQueryClient({
  queryRetry: customerReadShouldRetry,
  onError: (error: Error) => {
    if (error instanceof ApiError && error.status === 429) {
      // Resolved per toast, never hoisted: this module is evaluated before
      // `initI18n` runs, and the user can switch language afterwards, so a
      // module-scope lookup would freeze whatever language was current at boot.
      toast.error(i18n.t("errors.api.rate_limited"), {
        id: "rate-limit-toast",
        duration: 6000,
      });
    }
  },
});
